import Vue from 'vue'
import App from './App'
import router from './router'

//import Cesium from 'cesium/Cesium'
//import widgets from 'cesium/Widgets/widgets.css'
//import axios from 'axios'

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  mounted() {
  // var viewer = new Cesium.CesiumWidget('cesiumContainer')z
    /*var viewer = new Cesium.Viewer('cesiumContainer')

    var espoch = viewer.entities.add({
      name: 'Espoch',
      polygon: {
        hierarchy: Cesium.Cartesian3.fromDegreesArray([
          -78.675178, -1.661706,
          -78.670822, -1.655936,
          -78.681980, -1.646711,
          -78.688411, -1.648343,
          -78.681751, -1.654694,
          -78.682108, -1.657934,
          -78.681496, -1.659847,
          -78.675178, -1.661706
        ]),
        height: 100,
        extrudedHeight: 25,
        material: Cesium.Color.RED.withAlpha(0.5),
        outline: true,
        outlineColor: Cesium.Color.BLACK,
      }
    });
    espoch.description = '\<img\  width="50%"\style="float:left; margin: 0 1em 1em 0;"\  src="//cesiumjs.org/tutorials/Visualizing-Spatial-Data/images/Flag_of_Wyoming.svg"/>\ <p>\  Wyoming is a state in the mountain region of the Western \  United States.\ </p>\ <p>\   Wyoming is the 10th most extensive, but the least populous \   and the second least densely populated of the 50 United \   States. The western two thirds of the state is covered mostly \   with the mountain ranges and rangelands in the foothills of \   the eastern Rocky Mountains, while the eastern third of the \   state is high elevation prairie known as the High Plains. \   Cheyenne is the capital and the most populous city in Wyoming, \   with a population estimate of 62,448 in 2013.\</p>\ <p>\   Source: \   <a style="color: WHITE"\target="_blank"\     href="http://en.wikipedia.org/wiki/Wyoming">Wikpedia</a>\ </p>';

    var entity = viewer.entities.add({
      position: Cesium.Cartesian3.fromDegrees(-78.681751, -1.654694),
      model: {
        //uri : '../../../../Apps/SampleData/models/GroundVehicle/GroundVehicle.glb'
        uri: 'http://127.0.0.1:8887/Cesium-1.glb'
        //uri : 'assets/ingles.gltf'
      },
    });
    viewer.zoomTo(entity);

    console.log("se creo ");

    //axios.get('/api/buildings/').then((response) => {
    axios.get('/api/buildings/').then((response) => {
     // this.datos = response.data.data;
            console.log(response.data);
    });
    */
  }
})



// WEBPACK FOOTER //
// ./src/main.js